/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LicenseNotes} from '../models/LicenseNotes';

export interface GetLicenseNotes$Request {
    licenseId: number;
}

export interface GetLicenseNotes$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLicenseNotesRequest = createAction<PayloadData<void, GetLicenseNotes$Request>>('GET_LICENSE_NOTES__GET_LICENSE_NOTES__REQUEST');
export const getLicenseNotesSuccess = createAction<PayloadData<LicenseNotes, GetLicenseNotes$Request>>('GET_LICENSE_NOTES__GET_LICENSE_NOTES__SUCCESS');
export const getLicenseNotesFailure = createAction<PayloadData<Error, GetLicenseNotes$Request, true>>('GET_LICENSE_NOTES__GET_LICENSE_NOTES__FAILURE');

export const getLicenseNotesActions = [
    getLicenseNotesRequest,
    getLicenseNotesSuccess,
    getLicenseNotesFailure
] as const;

/**
 * @param {number} meta.licenseId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLicenseNotes = (meta: GetLicenseNotes$Request, config?: GetLicenseNotes$Config) => {
    return {
        CALL_API: {
            types: getLicenseNotesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/licenses/${meta.licenseId}/notes`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

